module.exports = __webpack_public_path__ + "chrono-diali-loading-256x256.svg";